<template>
    <div class="diy">
        <!-- 取消转诊 -->
        <el-dialog
                title="取消理由"
                :visible.sync="cancleVisible"
                width="40%"
                center>
            <el-divider></el-divider>
            <el-form>
                <el-form-item>
                    <el-input :autosize="{ minRows: 4, maxRows: 10}" placeholder="请填写取消理由" type="textarea" v-model="cancleCause" :maxlength="150" show-word-limit></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="Cancel">取 消</el-button>
                <el-button type="primary" @click="CancelClick" style="margin-left: 50px !important;">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 拒绝转诊 -->
        <el-dialog
                title="拒绝理由"
                :visible.sync="refuseFormVisible"
                width="40%"
                center>
            <el-divider></el-divider>
            <el-form>
                <el-form-item>
                    <el-input @input="changeLength" :autosize="{ minRows: 4, maxRows: 10}" placeholder="请填写拒绝理由最多输入150字..." type="textarea" v-model="refuseCause" :maxlength="150" ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="refuseCancel">取 消</el-button>
                <el-button type="primary" @click="refuse" style="margin-left: 50px !important;">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 同意转诊 -->
        <el-dialog
                title="确认时间"
                :visible.sync="affirmVisible"
                width="40%"
                center>
            <el-divider></el-divider>
            <el-form label-width="100px" :model="affirmForm">
                <el-form-item label="安排检查时间:">
                    <el-date-picker v-model="affirmForm.date" format="yyyy-MM-dd HH:mm" type="datetime" placeholder="请填写意向会诊时间" style="width: 100%;"></el-date-picker>
                </el-form-item>
                <el-form-item label="医生建议:">
                    <el-input @input="changeLength" :autosize="{ minRows: 4, maxRows: 10}" placeholder="请填写医生的相关建议最多输入150字..." type="textarea" v-model="affirmForm.context" :maxlength="150"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="affirmCancel">取 消</el-button>
                <el-button type="primary" @click="affirm" style="margin-left: 50px !important;">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 修改转诊时间 -->
        <el-dialog
                title="修改时间"
                :visible.sync="updateVisible"
                width="40%"
                center>
            <el-divider></el-divider>
            <el-form label-width="100px">
                <el-form-item label="安排检查时间:">
                    <el-date-picker v-model="updateDate" format="yyyy-MM-dd HH:mm" type="datetime" placeholder="请填写意向会诊时间" style="width: 100%;"></el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="updateCancel">取 消</el-button>
                <el-button type="primary" @click="update" style="margin-left: 50px !important;">确 定</el-button>
          </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "hos-dialog-detail",
        data(){
            return {
                refuseCause:"",//拒绝理由
                refuseFormVisible:false,//拒绝弹出框
                affirmForm:{
                    date:"",
                    context:""
                },
                affirmVisible:false,//同意确诊弹出框
                updateDate:"",//修改会诊的时间
                updateVisible:false,//修改会诊时间弹出框
                cancleVisible:false,//取消会诊
                cancleCause:""//取消理由
            }
        },
        methods:{
            Cancel(){
                this.cancleVisible=false;
                this.cancleCause = "";
            },
            CancelClick(){
                this.$emit('cancle',this.cancleCause);
                this.cancleVisible = false;
            },
            refuseCancel(){
                this.refuseFormVisible = false;
                this.refuseCause = "";
            },
            refuse(){
                this.$emit('refuse',this.refuseCause);
                this.refuseFormVisible = false;
            },
            affirmCancel(){
                this.affirmVisible = false;
                this.affirmForm.date = "";
                this.affirmForm.context = "";
            },
            affirm(){
                this.$emit('affirm',this.affirmForm);
                this.affirmVisible = false;
            },
            updateCancel(){
                this.updateVisible = false;
                this.updateDate = "";
            },
            update(){
                this.$emit('update',this.updateDate);
                this.updateVisible = false;
            },
            //上面是按钮事件 下面是外部调用弹出框事件
            start(dialogType){
                if(dialogType == 'refuse'){
                    this.refuseFormVisible = true;
                }else if(dialogType == 'affirm'){
                    this.affirmVisible= true;
                }else if(dialogType == 'cancle'){
                    this.cancleVisible = true;
                }else{
                    this.updateVisible = true;
                }
            },
            changeLength(){
                if(this.diseaseInfoForm.illnessDescription.length >= 150){
                    this.$message.error('字数超出限制。');
                }
            }
        }
    }
</script>

<style lang="scss">
.diy{
    .el-dialog__body{
        padding:0px 25px 15px !important;
    }
}
</style>